import { render, staticRenderFns } from "./allInfo.vue?vue&type=template&id=4d94899c&scoped=true&"
import script from "./allInfo.vue?vue&type=script&lang=js&"
export * from "./allInfo.vue?vue&type=script&lang=js&"
import style0 from "./allInfo.vue?vue&type=style&index=0&id=4d94899c&prod&lang=less&scoped=true&"
import style1 from "./allInfo.vue?vue&type=style&index=1&id=4d94899c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d94899c",
  null
  
)

export default component.exports